import { useEffect, useState, useRef, useCallback } from 'react';

function useSticky() {
  const [isSticky, setIsSticky] = useState(false);
  const element = useRef(null);

  const handleScroll = useCallback(() => {
    if (element?.current) {
      setIsSticky(element.current.getBoundingClientRect().top <= 90);
    }
  }, []);

  // This function handles scroll performance issues
  const debounce = useCallback(
    (func, wait: number = 10, immediate: boolean = true) => {
      let timeOut;
      return () => {
        const context = this;
        const args = { func, wait, immediate };
        const later = () => {
          timeOut = null;
          if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeOut;
        clearTimeout(timeOut);
        timeOut = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    },
    []
  );

  useEffect(() => {
    window.addEventListener('scroll', debounce(handleScroll), {
      capture: true
    });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll, debounce]);

  return { isSticky, element };
}

export default useSticky;
